module.exports = __webpack_public_path__ + "img/1526968940.ef40e46c.jpg";